export default __webpack_public_path__ + "static/media/Broadcasting.865781a1.png";